import type { BlockExportMapping } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { HomepageBlock1 } from "./HomepageBlock1";
import { HomepageBlock2 } from "./HomepageBlock2";
import { HomepageBlock2_1 } from "./HomepageBlock2_1";
import { HomepageBlock3 } from "./HomepageBlock3";
import { HomepageBlock4 } from "./HomepageBlock4";
import { HomepageBlock4_2 } from "./HomepageBlock4_2";
import { HomepageBlock5 } from "./HomepageBlock5";
import { HomepageBlock5_2 } from "./HomepageBlock5_2";
import { HomepageBlock6 } from "./HomepageBlock6";
import { HomepageBlock7 } from "./HomepageBlock7";
import { HomepageBlock8 } from "./HomepageBlock8";

export const homepageBlocks: BlockExportMapping = {
  HomepageBlock1,
  HomepageBlock2,
  HomepageBlock2_1,
  HomepageBlock3,
  HomepageBlock4,
  HomepageBlock4_2,
  HomepageBlock5,
  HomepageBlock5_2,
  HomepageBlock6,
  HomepageBlock7,
  HomepageBlock8,
};
